import { Injectable, Optional } from '../components/dependency-injection/decorators';
import { ApplicationLifecycleEvent } from '../components/event-manager/event/application-lifecycle.event';
import { Events } from '../components/event-manager/event/events';
import { Logger } from '../components/logger/logger';
import { EventSubscriberInterface } from '../interfaces/components/event-manager/subscriber/event-subscriber.interface';

@Injectable()
export class ApplicationSubscriber implements EventSubscriberInterface {
  constructor (@Optional() private readonly logger?: Logger) {
  }

  getSubscribedEvents (): { [key in Events]?: string } {
    return {
      [ Events.APPLICATION_PRE_RUN ]: 'onApplicationPreRun',
      [ Events.APPLICATION_POST_RUN ]: 'onApplicationPostRun',
      [ Events.APPLICATION_PRE_INIT ]: 'onApplicationPreInit',
      [ Events.APPLICATION_POST_INIT ]: 'onApplicationPostInit',
    };
  }

  public onApplicationPreRun (event: ApplicationLifecycleEvent): void {
    this.logger?.debug(`Pre run application`);
  }

  public onApplicationPostRun (event: ApplicationLifecycleEvent): void {
    this.logger?.debug(`Post run application`);
  }

  public onApplicationPreInit (event: ApplicationLifecycleEvent): void {
    this.logger?.debug(`Pre init application`);
  }

  public onApplicationPostInit (event: ApplicationLifecycleEvent): void {
    this.logger?.debug(`Post init application`);
  }
}
